<template>
  <b-modal
    ref="updateAttachmentNameModal"
    :title="$t('global.description.modifyFileName')"
    centered
    modal-class="update-name-modal"
    @shown="focusInput"
  >
    <b-row class="p-4">
      <b-col>
        <div class="form-label">
          <label>{{ $t('component.attachModal.fileName') }}</label>
        </div>
        <vt-input
          ref="filenameInput"
          v-model="internalFileName"
          class="form-control-sm"
        />
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <vt-loading-button
            class="btn--primary btn-sm"
            :params="{ promise: update }"
          >
            <i
              class="fal fa-save mr-2"
              aria-hidden="true"
            />
            {{ $t('global.save') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { cloneDeep } from 'lodash'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
const patientAttachmentService = () => import('@/api/resources/attachment/patientAttachmentService')
const caseAttachmentService = () => import('@/api/resources/attachment/caseAttachmentService')
const sampleAttachmentService = () => import('@/api/resources/attachment/sampleAttachmentService')
const portionAttachmentService = () => import('@/api/resources/attachment/portionAttachmentService')
const subportionAttachmentService = () => import('@/api/resources/attachment/subportionAttachmentService')
const complementaryAttachmentService = () => import('@/api/resources/attachment/complementaryAttachmentService')

export default {
    name: 'UpdateNameModal',
    props: {
        attachmentEntityType: { type: String },
        entitiesIdArray: { type: Array },
        fileName: { type: String },
        attachmentId: { type: Number }
    },
    data() {
        return {
            service: null,
            internalFileName: ''
        }
    },
    methods: {
        show() {
            this.service = null
            this.internalFileName = cloneDeep(this.fileName)
            const requestParameters = [...this.entitiesIdArray, this.attachmentId]
            switch (this.attachmentEntityType) {
            case ATTACHMENT_ENTITY_TYPE.PATIENT:
                patientAttachmentService().then(service => {
                    this.service = (fileName) => service.default.patchAttachment(...requestParameters, { filename: fileName })
                })
                break
            case ATTACHMENT_ENTITY_TYPE.CASE:
                caseAttachmentService().then(service => {
                    this.service = (fileName) => service.default.patchAttachment(...requestParameters, { filename: fileName })
                })
                break
            case ATTACHMENT_ENTITY_TYPE.SAMPLE:
                sampleAttachmentService().then(service => {
                    this.service = (fileName) => service.default.patchAttachment(...requestParameters, { filename: fileName })
                })
                break
            case ATTACHMENT_ENTITY_TYPE.PORTION:
                portionAttachmentService().then(service => {
                    this.service = (fileName) => service.default.patchAttachment(...requestParameters, { filename: fileName })
                })
                break
            case ATTACHMENT_ENTITY_TYPE.SUBPORTION:
                subportionAttachmentService().then(service => {
                    this.service = (fileName) => service.default.patchAttachment(...requestParameters, { filename: fileName })
                })
                break
            case ATTACHMENT_ENTITY_TYPE.COMPLEMENTARY:
                complementaryAttachmentService().then(service => {
                    this.service = (fileName) => service.default.patchAttachment(...requestParameters, { filename: fileName })
                })
                break
            }
            this.$refs.updateAttachmentNameModal.show()
        },
        focusInput() {
            this.$nextTick(() => {
                this.$refs.filenameInput.focus()
            })
        },
        async update() {
            const response = await this.$_toCallUnique(this.service(this.internalFileName))
            if (response) {
                this.$emit('attachmentNameUpdated')
                this.showToastSuccessGlobal(this.$tc('global.description.fileNameSuccessfullyChanged'))
                this.hide()
            }
        },
        hide() {
            this.$refs.updateAttachmentNameModal.hide()
        }
    }
}

</script>

<style lang="scss">
    .update-name-modal .modal-dialog {
        @include mq(desktop-wide, max) {
            width: 30%;
        }
        @include mq(desktop-wide, min) {
            width: 30%;
        }
        @include mq(tablet-wide, max) {
            width: 40%;
        }
    }

</style>
